import React from "react";
import Loading from "./loading";

const Layout = (props) => {
  return (
    <div className="w-screen h-screen">
      {props.loading < 3 && <Loading loading={props.loading} />}
      {props.children}
    </div>
  );
};

export default Layout;
